import { RestResource } from "./common"
import { SchemaDeSer, SchemaDeSerBuilder } from "./deser"

export class ForexTradingRequest extends RestResource {
  requestingCustomerId = ""
}

export const FOREX_TRADING_REQUEST_DESER: SchemaDeSer<ForexTradingRequest> =
  new SchemaDeSerBuilder(ForexTradingRequest)
    .ofInt("id")
    .ofString("requestingCustomerId")
    .toDeSer()
